module.exports = __webpack_public_path__ + "static/media/pwa-mdc-modal-alert-bg.e2d7fb6e.png";